export const TOO_MANY_REQUESTS = 429;

export const UNAUTHORIZED_ERROR = 430;
export const BAD_EMAIL_PASS_ERROR = 431;
export const EXISTING_USERNAME_ERROR = 432;
export const EXISTING_EMAIL_ERROR = 433;
export const BAD_CODE_ERROR = 434;
export const BAD_PARAMS_ERROR = 435;
export const BAD_PASS_ERROR = 436;
